import GlowButton from "../landing/GlowButton";

const FloatingGetStarted = () => {
  const handleGetStarted = () => {
    window.location.href = "/business/get-started";
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <GlowButton btnValue="free trial" btn1="2" onClick={handleGetStarted} />
    </div>
  );
};

export default FloatingGetStarted;
